// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"54673540","453":"dc261eae","855":"48648c87"}[chunkId] + ".chunk.js";
};